/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { EditButton, List, TextField } from 'react-admin'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import ListTitle from '../../components/ListTitle'
import Datagrid from '../../components/Datagrid/Datagrid'
import Filter from '../../components/Filter/FilterComponents'

const styles = {
    header: {
        display: 'none',
    },
}
const useStyles = makeStyles(styles)
export default function CheckListMasterList(props) {
    const { quickSearch } = props
    const classes = useStyles(props)
    return (
        <List
            sort={{ field: 'code', order: 'ASC' }}
            filters={<Filter {...props} />}
            {...props}
        >
            <>
                <ListTitle label="Banks" />
                <Datagrid {...props}>
                    <TextField label="Code" source="code" />
                    <TextField label="Description" source="description" />
                    {quickSearch ? (
                        <EditButton
                            headerClassName={classes.header}
                            basePath="/PY_CheckListMasterTAB"
                        />
                    ) : (
                        <EditButton basePath="/PY_CheckListMasterTAB" />
                    )}
                </Datagrid>
            </>
        </List>
    )
}

CheckListMasterList.defaultProps = {
    quickSearch: false,
}

CheckListMasterList.propTypes = {
    quickSearch: PropTypes.bool,
}
